import { render, staticRenderFns } from "./topSwipe.vue?vue&type=template&id=12cd8746&scoped=true"
import script from "./topSwipe.vue?vue&type=script&lang=js"
export * from "./topSwipe.vue?vue&type=script&lang=js"
import style0 from "./topSwipe.vue?vue&type=style&index=0&id=12cd8746&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12cd8746",
  null
  
)

export default component.exports